import { createFileRoute } from '@tanstack/react-router';

import { MyAttendancePage } from '@/features/me/my-work';

export const Route = createFileRoute('/_app/me/attendance')({ component: MyAttendancePage });
